module.exports = __webpack_public_path__ + "static/media/nn-Arbeidsminne-No-kjem-det-flei-tal.30a48ae3.mp3";